import React, {useState} from "react";
import Button from '../../components/CustomButtons/Button';
import MenuItem from '@material-ui/core/MenuItem';
import {makeStyles} from "@material-ui/core/styles";

// material-ui icons
import MoreVert from "@material-ui/icons/MoreVert";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import {useDispatch} from "react-redux";
import {unwrapResult} from '@reduxjs/toolkit'

import SuperGeneralDeleteModal from "./SuperGeneralDeleteModal"
import ErrorModal from "./ErrorModal"
import ListItemText from "@material-ui/core/ListItemText";
import {notification} from 'antd';
import Menu from "@material-ui/core/Menu";
import {withStyles} from "@material-ui/core/styles";
import {
    deleteStudyPlanReportDocument,
    fetchStudyPlanReportDocumentsByProgramSpecId
} from "../../reduxToolkit/features/StudyPlan/StudyPlanReportDocumentSlice";

const useStyles = makeStyles(styles);

const StyledMenu = withStyles({
    paper: {
        border: "1px solid #d3d4d5",
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
));

export default function DropDownStudyPlanReportButton(props) {

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [handledError, setHandledError] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDeleteModal = () => {
        setOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setOpen(false);
    };

    const handleOpenErrorModal = () => {
        setOpenErrorModal(true);
    };

    const handleCloseErrorModal = () => {
        setOpenErrorModal(false);
    };

    const handleDeleteItem = async (id) => {
        dispatch(deleteStudyPlanReportDocument(id))
            .then(unwrapResult)
            .then((originalPromiseResult) => {
                // handle result here
                openNotificationWithIcon('success', `Deleted`)
                dispatch(fetchStudyPlanReportDocumentsByProgramSpecId(props.progId));
            })
            .catch((rejectedValueOrSerializedError) => {
                // handle error here
                setHandledError(rejectedValueOrSerializedError)
                handleOpenErrorModal()
            })
    }

    const openNotificationWithIcon = (type, msg) => {
        notification[type]({
            message: type,
            description: msg,
            top: 50,
            duration: 2
        });
    };

    return (
        <div>
            <Button
                // aria-describedby={id}
                aria-controls="customized-menu"
                variant="contained"
                color="primary"
                onClick={handleClick}
                justIcon
                round
                aria-haspopup="true"
            >
                <MoreVert/>
            </Button>

            <StyledMenu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >

                <MenuItem
                    onClick={() => {
                        handleOpenDeleteModal();
                        handleClose();
                    }}>
                    <ListItemText primary="Delete"/>
                </MenuItem>
            </StyledMenu>
            <ErrorModal open={openErrorModal} handleClose={handleCloseErrorModal} handledError={handledError}/>
            <SuperGeneralDeleteModal
                delete_Element={handleDeleteItem}
                Element_ID={props.id}
                open={open}
                handleClose={handleCloseDeleteModal}

            />
        </div>
    );
}
